import MapProctorService from './mapProctorService';

export interface CreateMapStudentRequest {
  first_name: string;
  last_name: string;
  email: string;
  school: string;
  grade: string;
}

export interface CreateMapStudentResult {
  success: boolean;
  studentId?: string;
  error?: string;
}

export async function createMapStudent(
  input: CreateMapStudentRequest
): Promise<CreateMapStudentResult> {
  try {
    const mapProctorService = MapProctorService.getInstance();
    return await mapProctorService.createStudent(input);
  } catch (error) {
    console.error(error);
    throw error;
  }
}
